// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Dallam from '../../../Texas/data/counties/Dallam.geo.json'
import Sherman from '../../../Texas/data/counties/Sherman.geo.json'
import Hansford from '../../../Texas/data/counties/Hansford.geo.json'
import Ochiltree from '../../../Texas/data/counties/Ochiltree.geo.json'
import Lipscomb from '../../../Texas/data/counties/Lipscomb.geo.json'
import Hartley from '../../../Texas/data/counties/Hartley.geo.json'
import Moore from '../../../Texas/data/counties/Moore.geo.json'
import Hutchinson from '../../../Texas/data/counties/Hutchinson.geo.json'
import Roberts from '../../../Texas/data/counties/Roberts.geo.json'
import Hemphill from '../../../Texas/data/counties/Hemphill.geo.json'
import Oldham from '../../../Texas/data/counties/Oldham.geo.json'
import Potter from '../../../Texas/data/counties/Potter.geo.json'
import Carson from '../../../Texas/data/counties/Carson.geo.json'
import Gray from '../../../Texas/data/counties/Gray.geo.json'
import Wheeler from '../../../Texas/data/counties/Wheeler.geo.json'
import Deaf_Smith from '../../../Texas/data/counties/Deaf_Smith.geo.json'
import Randall from '../../../Texas/data/counties/Randall.geo.json'
import Armstrong from '../../../Texas/data/counties/Armstrong.geo.json'
import Donley from '../../../Texas/data/counties/Donley.geo.json'
import Collingsworth from '../../../Texas/data/counties/Collingsworth.geo.json'
import Parmer from '../../../Texas/data/counties/Parmer.geo.json'
import Swisher from '../../../Texas/data/counties/Swisher.geo.json'
import Briscoe from '../../../Texas/data/counties/Briscoe.geo.json'
import Hall from '../../../Texas/data/counties/Hall.geo.json'
import Childress from '../../../Texas/data/counties/Childress.geo.json'

const counties = {
  Dallam,
  Sherman,
  Hansford,
  Ochiltree,
  Lipscomb,
  Hartley,
  Moore,
  Hutchinson,
  Roberts,
  Hemphill,
  Oldham,
  Potter,
  Carson,
  Gray,
  Wheeler,
  Deaf_Smith,
  Randall,
  Armstrong,
  Donley,
  Collingsworth,
  Parmer,
  Swisher,
  Briscoe,
  Hall,
  Childress
}

export default counties
